<template>
  <div
    class="agent-insight-overlay"
    id="agentInsightModal"
    data-agent-insight-overlay
    :aria-hidden="!open"
    tabindex="-1"
    @click="handleOverlayClick"
    @keydown.escape="close"
  >
    <div class="agent-insight-window">
      <!-- 头部 -->
      <div class="agent-insight-head">
        <div>
          <div class="agent-insight-eyebrow">{{ sectionMeta.eyebrow }}</div>
          <div class="agent-insight-title">{{ sectionMeta.title }}</div>
        </div>
        <button class="agent-insight-close" type="button" @click="close">×</button>
      </div>
      <!-- 文本区 -->
      <div class="agent-insight-body">
        <div v-if="sectionsLoading" class="agent-insight-loading">加载中...</div>
        <textarea
          v-else
          class="agent-insight-textarea"
          :value="draftValue"
          @input="onTextareaInput"
          :placeholder="sectionMeta.placeholder"
          rows="9"
        ></textarea>
      </div>
      <!-- 底部按钮 -->
      <div class="agent-insight-footer">
        <div class="agent-insight-footer-left">
        </div>
        <div class="agent-insight-footer-right">
          <button class="agent-insight-text-btn" type="button" @click="reset">恢复默认</button>
          <button class="agent-insight-save-btn" type="button" @click="save">{{ sectionMeta.saveLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

const SECTION_META = {
  memory:   { eyebrow: 'MEMORY INSPECT',   title: '记忆',     placeholder: '输入记忆内容...',       saveLabel: '保存记忆' },
  soul:     { eyebrow: 'SOUL INSPECT',     title: '个性',     placeholder: '输入 Agent 个性设定...', saveLabel: '保存个性' },
  identity: { eyebrow: 'IDENTITY INSPECT', title: '身份',     placeholder: '输入身份定义...',       saveLabel: '保存身份' },
  persona:  { eyebrow: 'PERSONA INSPECT',  title: '人格',     placeholder: '输入人格特征...',       saveLabel: '保存人格' },
  style:    { eyebrow: 'STYLE INSPECT',    title: '风格',     placeholder: '输入回复风格...',       saveLabel: '保存风格' },
  system:   { eyebrow: 'SYSTEM INSPECT',   title: '系统指令', placeholder: '输入系统指令...',       saveLabel: '保存系统指令' },
}

export default {
  name: 'AgentInsightModal',
  data() {
    return { draftValue: '' }
  },
  computed: {
    ...mapState(['agentInsightModal', 'agentPromptSectionsLoading']),
    ...mapGetters(['agentSoulText', 'agentMemoryText', 'agentPromptSectionsForCurrent']),
    open() { return this.agentInsightModal.open },
    type() { return this.agentInsightModal.type || 'memory' },
    sessionKey() { return this.agentInsightModal.sessionKey || this.$store.state.currentSessionKey },
    sectionMeta() { return SECTION_META[this.type] || SECTION_META.memory },
    sectionsLoading() { return this.agentPromptSectionsLoading },
    currentSectionValue() {
      const sections = this.agentPromptSectionsForCurrent
      if (sections && sections[this.type] !== undefined) return sections[this.type]
      return ''
    }
  },
  methods: {
    ...mapActions(['closeAgentInsightModal']),
    close() { this.closeAgentInsightModal() },
    handleOverlayClick(e) {
      if (!e.target.closest('.agent-insight-window')) this.close()
    },
    onTextareaInput(e) {
      this.draftValue = e.target.value
    },
    save() {
      const val = this.draftValue
      const item = this.$store.state.sessionItems.find(s => s.key === this.sessionKey)
      const convId = item ? item.conversationId : this.sessionKey
      // 调用接口保存
      this.$store.dispatch('updateAgentPromptSection', {
        conversationId: convId,
        sectionKey: this.type,
        value: val
      })
      this.close()
    },
    reset() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.sessionKey)
      const convId = item ? item.conversationId : this.sessionKey
      this.$store.dispatch('resetAgentPromptSection', {
        conversationId: convId,
        sectionKey: this.type
      })
    },
    appendMemory() {
      const current = (this.draftValue || '').trimEnd()
      const line = '新增记忆：持续跟进当前话题进度，并在交付前同步最新结论。'
      this.draftValue = current ? current + '\n' + line : line
    }
  },
  mounted() {
    // v-if 创建时 open 已经是 true，直接赋值
    this.draftValue = this.currentSectionValue
  },
  watch: {
    open(v) {
      if (v) this.$nextTick(() => { if (this.$el) this.$el.focus() })
    },
    type() {
      this.draftValue = this.currentSectionValue
    },
    agentPromptSectionsForCurrent() {
      if (this.open) {
        this.draftValue = this.currentSectionValue
      }
    }
  }
}
</script>
